import { render, staticRenderFns } from "./DashboardLayoutV2.vue?vue&type=template&id=0fa4684d&"
import script from "./DashboardLayoutV2.vue?vue&type=script&lang=js&"
export * from "./DashboardLayoutV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports